import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { Col, Row, Text } from "nectar-ui";
import { sizes } from "./utils/constants/style";
import { transparentize } from "./utils/helpers/transparentize";
import { theme } from "nectar-ui";
import { NectarTheme } from "@nectarTypes";

const standardTheme = theme.standard;

// TODO: Create Nectar theme and use it here.
export const DashboardModuleWrapper = styled.div<any>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacings.lg};
    max-width: 2113px;
  `}
`;

export const ChartSectionWrapper = styled(Row)<any>`
  ${({ theme }) => css`
    row-gap: ${theme.spacings.lg};
  `}
`;

export const TabWrapper = styled.div<any>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: 0 !important;
    row-gap: ${theme.spacings.lg} 0;
  `}
`;

export const CustomChartStyleWrapper = styled.div<any>`
  ${({ theme, legendMaxWidth }) => css`
    max-width: 1012px;

    .apexcharts-inactive-legend {
      opacity: 1 !important;

      & span:first-child {
        opacity: 0.45 !important;
      }
    }

    .apexcharts-legend-series {
      border-radius: ${theme.spacings.xs};
      padding: ${theme.spacings.xs};
      color: ${theme.colors.gray300};

      &:hover {
        cursor: pointer;
        background-color: ${theme.colors.gray100};
      }
    }

    .apexcharts-legend-marker {
      margin-right: ${theme.spacings.xs};
    }

    .apexcharts-xaxistooltip {
      display: none !important;
    }

    .apexcharts-legend-text {
      color: ${theme.colors.gray900} !important;
      font-size: ${theme.typography.text.md} !important;
      font-weight: ${theme.fontWeight.regular} !important;

      ${legendMaxWidth
        ? css`
            max-width: 84px;
            text-wrap: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            ${theme.breakpoints.sm} {
              max-width: 128px;
            }
          `
        : ""}
    }
  `}
`;

export const ToggletipText = styled(Text)`
  margin: 0 !important;
`;

export const ToggletipTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

/**
 * This wrapper is used to create a striped patterns (alternate colors) in stacked bar charts in
 * Apexcharts, since the 'colors' param alternate the series instead of x axis when the bars are
 * stacked.
 *
 * @param {string} evenColor - Set all the colors in apexcharts as the odd color and send a
 * color string in this parameter for the even color.
 * @returns {JSX.Element} Returns a wrapper to use around the chart element.
 */
export const StripedColorStackedBarChartWrapper = styled.div<NectarTheme & { evenColor: string }>`
  ${({ theme, evenColor }) => css`
    .apexcharts-series path:nth-child(even) {
      fill: ${theme.colors[evenColor]};
    }
  `}
`;

export const DashboardCol = styled(Col)`
  padding: 0 0 0 12px;
`;

const { XS, SM, LG } = sizes;

export const shadows = {
  [XS]: `box-shadow: 0 1px 2px 1px ${transparentize(standardTheme.colors.shadows, 0.2)}`,
  [SM]: `box-shadow: 0 1px 4px 1px ${transparentize(standardTheme.colors.shadows, 0.2)}`,
  [LG]: `box-shadow: 0 1px 16px 1px ${transparentize(standardTheme.colors.shadows, 0.1)}`,
};
export const shadowsVal = {
  [XS]: `0 1px 2px 1px ${transparentize(standardTheme.colors.shadows, 0.2)}`,
  [SM]: `0 1px 4px 1px ${transparentize(standardTheme.colors.shadows, 0.2)}`,
  [LG]: `0 1px 16px 1px ${transparentize(standardTheme.colors.shadows, 0.1)}`,
};
